import { useRef, useState } from 'react';
import { PlusIcon } from 'lucide-react';

import { useChatStore } from '@/chat/hooks/use-chat-store';
import { closeActiveStream } from '@/chat/hooks/use-suggestion';
import { PromptInputButton } from '@/components/ai-elements/prompt-input';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useAudioPlayerStore } from '@/music/hooks/use-audio-player-store';

interface NewChatButtonProps {
  onConfirm: () => void;
}

export const NewChatButton = ({ onConfirm }: NewChatButtonProps) => {
  const hasMessages = useChatStore((state) => state.messages.length > 0);
  const [open, setOpen] = useState(false);
  // 텍스트 입력은 uncontrolled textarea라 owner form의 reset으로 초기화
  const formRef = useRef<HTMLFormElement | null>(null);

  // 진행 중 스트림을 먼저 닫아 리셋 이후 이벤트 수신을 차단
  const handleConfirm = () => {
    closeActiveStream();
    useChatStore.getState().reset();
    useAudioPlayerStore.getState().stop();
    formRef.current?.reset();
    onConfirm();
    setOpen(false);
  };

  return (
    <>
      <PromptInputButton
        disabled={!hasMessages}
        onClick={(event) => {
          formRef.current = event.currentTarget.form;
          setOpen(true);
        }}
      >
        <PlusIcon className="size-4" />새 대화
      </PromptInputButton>
      <Dialog onOpenChange={setOpen} open={open}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>새 대화를 시작할까요?</DialogTitle>
            <DialogDescription>현재 대화 내용이 삭제되며 복구할 수 없습니다</DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button onClick={() => setOpen(false)} variant="outline">
              취소
            </Button>
            <Button onClick={handleConfirm}>새 대화 시작</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
